export function getElementById(id) {
  return document.getElementById(id);
}
